import wnumb from 'wnumb';
window.wNumb = wnumb;